<template>
  <slot />
</template>

<script setup lang="ts">
import { provide } from 'vue'
import { MODAL_CLOSE_KEY, MODAL_CONFIRM_KEY } from '../../types/modal.types'

interface Props {
  modalId: string
  close: (data?: unknown) => void
  confirm: (data?: unknown) => void
}

const props = defineProps<Props>()

provide(MODAL_CLOSE_KEY, props.close)
provide(MODAL_CONFIRM_KEY, props.confirm)

// Also provide with string keys for easier access
provide('modalClose', props.close)
provide('modalConfirm', props.confirm)
</script>
